import { FC } from 'react';
import { useTranslation } from 'react-i18next';
// Types
import { SubscriptionStatus } from 'app/store/Subscriptions/Subscriptions.types';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { SubscriptionsActions } from 'app/store/Subscriptions/Subscriptions.slice';
// Selectors
import { selectAccountsAsOptions } from 'app/store/AccountsManagement/AccountsManagement.selectors';
import { selectPackagesAsOptions } from 'app/store/BillingPackages/BillingPackages.selectors';
import { selectParams } from 'app/store/Subscriptions/Subscriptions.selectors';
// Mui
import { Box, Typography } from '@mui/material';
// Components
import { Autocomplete } from 'app/components/Mui/Autocompletes';

const SubscriptionsFilter:FC = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const accountOptions = useAppSelector(selectAccountsAsOptions);
  const packageOptions = useAppSelector(selectPackagesAsOptions);
  const params = useAppSelector(selectParams);

  const handleChange = (field:keyof typeof params, value:any) => {
    dispatch(SubscriptionsActions.setParams({ [field]: value }));
  }

  return (
    <Box sx={{ display: 'flex', gap: 4 }}>
      <Autocomplete
        value={params.accountId}
        onChange={(value:any) => handleChange('accountId', value)}
        options={accountOptions || []}
        TextFieldProps={{
          label: t('labels.companyAccount'),
          margin: "none",
          size: "small"
        }}
        renderOption={(props, option) => (
          <li {...props} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }} key={option.value}>
            <Typography variant="subtitle1">{option.label}</Typography>
            {option.props.address ? (
              <Typography variant="caption">{option.props.address}</Typography>
            ) : null}
          </li>
        )}
      />
      <Autocomplete
        value={params.subscriptionPackageId}
        onChange={(value:any) => handleChange('subscriptionPackageId', value)}
        options={packageOptions || []}
        TextFieldProps={{
          label: t('labels.subscriptionPackage'),
          margin: "none",
          size: "small"
        }}
      />
      <Autocomplete
        sx={{
          flexShrink: 0,
          width: 300
        }}
        value={params.status}
        onChange={(newValue) => handleChange('status', newValue)}
        options={[
          { value: SubscriptionStatus.Active, label: t('labels.active') },
          { value: SubscriptionStatus.Trialing, label: t('labels.trialing') },
          { value: SubscriptionStatus.Cancelled, label: t('labels.cancelled') },
        ]}
        TextFieldProps={{
          label: t('labels.status'),
          name: 'statuses',
          margin: "none",
          size: "small"
        }}
        slotProps={{
          chip: {
            sx: {
              height: 20
            },
            size: 'small'
          }
        }}
        multiple={true}
        limitTags={2}
      />
    </Box>
  )
}

export default SubscriptionsFilter;